import * as yup from 'yup'

import { IRuleCostFormValues } from 'features/PartnerCost/types'
import { defineMessages, IntlShape } from 'react-intl'

const routeServicesMessages = defineMessages({
  required: {
    id: 'partnerCost.form.routeServices.required',
    defaultMessage: 'You must select at least one route service'
  }
})

const partnerVehiclesMessages = defineMessages({
  required: {
    id: 'partnerCost.form.partnerVehicles.required',
    defaultMessage: 'You must select at least one vehicle'
  }
})

const operationDaysMessages = defineMessages({
  required: {
    id: 'partnerCost.form.operationDays.required',
    defaultMessage: 'You must select at least one operation day'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IRuleCostFormValues> => {
  return yup.object().shape({
    partner: yup
      .object()
      .shape({
        id: yup.string().required(),
        name: yup.string().required()
      })
      .optional()
      .nullable(),
    partnerVehicles: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(),
          name: yup.string().required(),
          capacity: yup.number().required(),
          externalID: yup.string().nullable()
        })
      )
      .min(1, intl.formatMessage(partnerVehiclesMessages.required)),
    routes: yup.array().of(
      yup.object().shape({
        id: yup.string().required(),
        name: yup.string().required()
      })
    ),
    routeServices: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string().required(),
          code: yup.string().required()
        })
      )
      .min(1, intl.formatMessage(routeServicesMessages.required)),
    startDate: yup.date().required(),
    endDate: yup.date().nullable(),
    operationDays: yup.array().of(yup.number().required()).min(1, intl.formatMessage(operationDaysMessages.required))
  })
}
